import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { ChallengeLinkShapeIcon, EditIconBranding } from "../../../utils/icons";



const BannerWrapper = styled.div`
  width: 100%;
  width: 404px;
  min-height: 126px;
  border-radius: 12px;
  background: ${({ bgColor }) => bgColor};
  position: relative;
  ${'' /* overflow: hidden; */}
  display: flex;
  flex-direction:column;
  ${'' /* align-items: center; */}
  justify-content:center;
  padding: 20px;
  border: ${({ color }) => `0.75px solid ${color}`};
  border-radius: 12px;
  margin:20px 0px;
`;

const ClipLayer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: 12px;
  z-index: 0;
`;

/* Left Decorative Shape */
const LeftShape = styled.div`
  position: absolute;
  left: 0;
  ${'' /* bottom: -60px; */}
  width: 260px;
  ${'' /* height: 200px; */}
  background: ${({ shapeColor }) => shapeColor};
  opacity: 0.5;
  border-radius: 50%;
  z-index:1;
  height:100%;
`;

/* Right Icon Container */
const RightIcon = styled.div`
  position: absolute;
  right: -2px;
  ${'' /* bottom: 8px; */}
  ${'' /* opacity: 0.6; */}
`;

/* Right Icon Container */
const RightButton = styled.div`
z-index:10;
  ${'' /* position: absolute; */}
  ${'' /* right: 15%; */}
  ${'' /* bottom: 8px; */}
`;

const Content = styled.div`
  z-index: 2;
  color: ${({ textColor }) => textColor};
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 30px;
margin-bottom:16px;

`;

const EditIconWrapper = styled.button`
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 20;
  border: none;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0.75px solid #DCDCDC;
  width:32px;
  height:32px;
  ${'' /* padding: 10px; */}
`;

const ChallengeLinkBanner = ({
  bgColor = "#F1F8F2",
  shapeColor = "#BDDDC2",
  textColor = "#1F2937",
  text = "Connect your calendar to schedule sessions",
  rightIcon,
  rightButton,
  color,
  edit,
  onEdit
}) => {
  useEffect(()=>{},[])
  return (
    <BannerWrapper bgColor={bgColor} color={color}>
      {edit && (
        <EditIconWrapper onClick={onEdit}>
          {EditIconBranding()}
        </EditIconWrapper>
      )}
      <ClipLayer><LeftShape>
        {ChallengeLinkShapeIcon(shapeColor)}
      </LeftShape></ClipLayer>
      <Content textColor={textColor}>{text}</Content>
      <RightIcon>{rightIcon}</RightIcon>
      <RightButton>{rightButton}</RightButton>
    </BannerWrapper>
  );
};

ChallengeLinkBanner.propTypes = {
  bgColor: PropTypes.string,
  shapeColor: PropTypes.string,
  textColor: PropTypes.string,
  text: PropTypes.string,
  rightIcon: PropTypes.node,
  rightButton:PropTypes.node,
  color:PropTypes.string,
  edit:PropTypes.bool,
  onEdit:PropTypes.func
};

export default ChallengeLinkBanner;
